import React from 'react';

import { AclStateExplanation } from './AclStateExplanation';
import { toAclDisplayValue } from './redaction';

interface AclRedactedCellProps {
  value: unknown;
  label: string;
}

const styles: Record<string, React.CSSProperties> = {
  cell: {
    display: 'inline-flex',
    alignItems: 'center',
    minHeight: 24,
    minWidth: 96,
    maxWidth: '100%',
    padding: '3px 8px',
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1.35,
  },
  visible: {
    color: '#e5e7eb',
  },
  redacted: {
    color: '#fecaca',
    background: '#7f1d1d',
    border: '1px solid #ef4444',
  },
  unavailable: {
    color: '#fde68a',
    background: '#78350f',
    border: '1px solid #f59e0b',
  },
};

export function AclRedactedCell({ value, label }: AclRedactedCellProps) {
  const display = toAclDisplayValue(value);
  const style = {
    ...styles.cell,
    ...styles[display.state],
  };

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      <span
        aria-label={`${label}: ${display.ariaLabel}`}
        data-acl-cell-state={display.state}
        data-sort-value={display.sortValue ?? ''}
        data-export-value={display.exportValue ?? ''}
        style={style}
      >
        {display.text}
      </span>
      {display.state !== 'visible' && (
        <AclStateExplanation
          kind={display.state}
          id={`acl-cell-${label.replace(/[^a-zA-Z0-9_-]/g, '-')}-${display.state}`}
        />
      )}
    </span>
  );
}
